import { create } from "zustand";

type ClaimBenefitData = {
  claimBenefit: Record<string, any> | null;

  setClaimBenefit: (data: Record<string, any>) => void;
};

export const useClaimBenefitStore = create<ClaimBenefitData>((set, get) => ({
  claimBenefit: null,

  setClaimBenefit: (data) => set({ claimBenefit: data }),

  getFullPayload: () => {
    const { claimBenefit } = get();
    const payload: Record<string, any> = {
      claimBenefit,
    };

    return payload;
  },
  reset: () =>
    set({
      claimBenefit: null,
    }),
}));
